<template>
  <div>
    <Modal 
      :id="modalId" 
      buttonName="CLOSE"
      ref="modal"
      :title="`You joined the group`" 
      @button="closeModal()" 
    >
      <div class="modal-body text-center">
        <slot name="default">
          <p class="text-justify">
            {{
              `Welcome to the ${groupName} group!`
            }} 
          </p>
          <span v-if="fromFeed" class="text">
            Click
            <p @click="closeModal">
              <router-link :to="`/s-app/group-page/${groupId}`" class="text">here</router-link >
            </p>
            to go to the group's home page.
          </span> 
        </slot>
      </div>
    </Modal>
  </div>
</template>
<script>
import Modal from "@/components/atoms/Modal.vue";
import { mapGetters } from "vuex";
import GroupHelperVue from "../../mixins/GroupHelper.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
export default {
  name: "ModalWelcomeGroup",
  mixins: [GroupHelperVue, ChatHelperVue, UserHelperVue],
  components: {
    Modal,
  },
  props: {
    fromFeed: { type: Boolean, default: false },
    id: null,
    name: String,
    groupKey: null,
  },
  data() {
  },
  methods: {
    closeModal() {
      this.$refs.modal.closeModal();
    },
    homePage() {
      this.$router.push({
        path: "`/s-app/group-page/`${groupId}",
        query: {redirect: this.redirectTo},
      });
      this.$refs.modal.closeModal();
    },
    
  },
  beforeUpdate() {
      this.text = this.defaultText;
    },
  computed: {
    ...mapGetters(["isUserAuthenticated"]),
    groupName() {
      if (this.name) return this.name;
      return this.getCurrentGroup.name;
    },
    groupId() {
      if (this.groupKey) {
        return this.groupKey;
      }
      return this.getCurrentGroup.groupKey;
    },
    modalId() {
      let id = "welcome-modal";
      if (this.id) {
        id += this.id;
      }
      return id;
    },
  },
};
</script>
<style lang="scss" scoped>
.text-justify {
  text-align-last: center;
  font-size: 18px;
  font-weight: bold;
  margin-top: 30px;
  margin-bottom: 40px;
}
.body-text {
  text-align-last: center;
  font-size: 14px;
  font-weight: normal;
}
.home-page {
  text-decoration: underline;
  cursor: pointer !important;
  color: $primary;
}
.text {
  display: flex;
  justify-content: space-between;
  font-size: 15px;
}
.modal-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>